var exports = {
  "kZ": "x61f99309--04880c--list-desktop",
  "Cv": "x61f99309--04880c--list-mobile",
  "LF": "x61f99309--04880c--empty-list",
};

module.exports = exports;
